import { TwoFALoginChallenge } from "@src/components/modules/auth/2fa-login-challenge";
import { NoIndexHead } from "@src/components/widgets/NoIndexHead/NoIndexHead";
import { createFileRoute } from "@tanstack/react-router";

const AuthTwoFactorChallenge = () => {
  return (
    <>
      <NoIndexHead />
      <TwoFALoginChallenge />
    </>
  );
};
export const Route = createFileRoute("/auth/two-factor/challenge")({
  component: AuthTwoFactorChallenge,
});
